<template>
  <DSButton
    :class="DS_DRAG_HANDLE_CLASSES.DragHandle"
    :aria-label="props.ariaLabel"
    :disabled="props.disabled"
    variant="secondary"
    size="sm"
    type="button"
    prefix-icon="menu-rich"
    data-cy="ds-drag-handle"
  />
</template>

<script setup lang="ts">
import DSButton from "../../button/components/DSButton.vue";
import { DS_DRAG_HANDLE_CLASSES } from "@/src/design_system/button_and_controls/drag_handle/constants/classes";
import type { DSDragHandleProps } from "@/src/design_system/button_and_controls/drag_handle/types/props";

const props = withDefaults(defineProps<DSDragHandleProps>(), {
  ariaLabel: "Drag to reorder",
  disabled: false,
});
</script>
